<template>
  <div class="container mx-auto">
    <div
      class="flex flex-col lg:flex-row items-center lg:justify-between gap-5"
    >
      <div class="card w-full rounded-[15px]">
        <div class="flex justify-center items-center gap-2">
          <h1 class="text-center text-[22px] font-bold pb-1 pt-1">
            Total Campaigns
          </h1>
          <tool-tip
            title="Total Campaigns"
            discription="Total amount of created awareness and conversions campaigns by your organization."
          >
          </tool-tip>
        </div>
        <div class="flex items-center justify-center">
          <div class="flex flex-col items-center justify-center mr-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ awarenessCampaign }}
            </p>
            <p>Awareness</p>
          </div>
          <hr class="h-10 w-[1px] bg-black opacity-40" />
          <div class="flex flex-col items-center justify-center ml-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ conversionsCampaign }}
            </p>
            <p>Conversions</p>
          </div>
        </div>
      </div>

      <div class="card w-full rounded-[15px]">
        <div class="flex justify-center items-center gap-2">
          <h1 class="text-center text-[22px] font-bold pb-1 pt-1">
            Active Campaigns
          </h1>
          <tool-tip
            title="Active Campaigns"
            discription="Current amount of ongoing awareness and conversions campaigns."
          >
          </tool-tip>
        </div>
        <div class="flex items-center justify-center">
          <div class="flex flex-col items-center justify-center mr-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ activeAwarenessCount }}
            </p>
            <p>Awareness</p>
          </div>
          <hr class="h-10 w-[1px] bg-black opacity-40" />
          <div class="flex flex-col items-center justify-center ml-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ activeConversionsCount }}
            </p>
            <p>Conversions</p>
          </div>
        </div>
      </div>
<!--
      <div class="card w-full rounded-[15px]">
        <div class="flex justify-center items-center gap-2">
          <h1 class="text-center text-[22px] font-bold pb-1 pt-1">
            Online Screens
          </h1>
          <tool-tip
            title="Online Screens"
            discription="Total amount of our advertising screens."
          >
          </tool-tip>
        </div>
        <div class="flex items-center justify-center">
          <div class="flex flex-col items-center justify-center mr-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ OnlineUsers }}
            </p>
            <p>Online</p>
          </div>
          <hr class="h-10 w-[1px] bg-black opacity-40" />
          <div class="flex flex-col items-center justify-center ml-4">
            <p class="text-primary text-[26px] font-semibold">
              {{ OfflineUsers }}
            </p>
            <p>Offline</p>
          </div>
        </div>
      </div> -->
    </div>

   <div class="flex gap-5 items-center my-5 flex-wrap lg:flex-nowrap">


    <div class="w-full flex lg:w-3/4 md:bg-[url('../src/assets/lottie/36CampaignBanner.png')] bg-[url('../src/assets/lottie/380px-new.png')] md:h-[230px] h-[380px] bg-cover bg-left py-10 px-11 md:p-5 rounded-lg
                md:flex-row md:items-center ">

          <div class="md:relative flex">

            <div class="flex flex-col md:items-start items-center md:justify-end justify-between md:pl-8">

              <p class="text-[28px] font-semibold md:w-[450px] md:text-start text-center">Advertise on the <span class="text-primary">Road</span> and get noticed!</p>

              <div class="md:absolute md:top-6 md:mt-0 mt-9 md:left-[400px] lg:left-[350px] xl:left-[420px] md:w-52 md:h-52 w-48 h-48 bg-contain bg-no-repeat bg-center bg-[url('../src/assets/lottie/36Currency.svg')] md:bg-[url('../src/assets/lottie/36CurrencyDesktop.svg')]"></div>

              <router-link to="/add-campaign">
                  <button class="bg-primary p-3 rounded-lg text-white text-xl mt-8">Create Campaign</button>
                </router-link>

            </div>

          </div>

      </div>

      <div class="w-full lg:w-1/4 bg-white card md:h-[230px] rounded-[15px]">
        <p class="text-primary text-center font-semibold text-2xl">Our Clients</p>
        <div class="max-h-96 mb-4">
          <Slider />
        </div>
      </div>
    </div>


    <div class="card rounded-[15px]">
      <div class="flex items-center justify-between mb-6">
        <p class="text-[26px] font-bold">Live Heatmap</p>
        <tool-tip
          discription="Monitor and track  your live campaigns in real-time"
          title="Heatmap"
        ></tool-tip>
      </div>
      <!-- <GoogleHeatmap :point="points" class="rounded-[5px]" /> -->
      <heat-map :heatmapData="points" class="w-full h-full" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import axios from "axios";
import Card from "../components/UI/Cards/Card.vue";
// import LineChart from "../components/UI/Chats/LineChart.vue";
// import RadialBar from "../components/UI/Chats/RadialBar.vue";
// import GoogleHeatmap from "../components/Map/GoogleHeatmap.vue";GoogleHeatmap,
import store from "../store";
import { createPopper } from "@popperjs/core";
import ToolTip from "../components/UI/ToolTip.vue";
import Slider from "../components/UI/Slider.vue";
import HeatMap from "../components/Map/HeatMap.vue";
import AreaCharts from "../components/UI/Chats/AreaCharts.vue";

export default {
  components: { Card, ToolTip, Slider, HeatMap, AreaCharts },
  data() {
    return {
      updateTimer: null,
      tooltipShow: false,
      options: {},
      heatMap: "",
      campaign: [],
      campaignIds: [],
      campaignId: null,
      campaignTitle: [],
      points: [
        { lat: 31.223348683333334, lng: 30.060142433333333 },
        // { lat: 37.786564, lg: -122.440209 },
        // { lat: 37.786905, lng: -122.44027 },
        // { lat: 37.786956, lnng: -122.440279 },
        // { lat: 37.800224, lng: -122.43352 },
        // { lat: 37.800155, lng: -122.434101 },
        // { lat: 37.80016, lng: -122.43443 },
        // { lat: 37.800378, lng: -122.434527 },
        // { lat: 37.800738, lng: -122.434598 },
        // { lat: 37.800938, lng: -122.43465 },
        // { lat: 37.801024, lng: -122.434889 },
        // { lat: 37.800955, lng: -122.435392 },
        // { lat: 37.800886, lng: -122.435959 },
      ],
      isOptionsExpanded: false,
      selectedOption: "Select an Option",
      // options: ["EG Bank Youth - Awareness", "EG Bank Youth - promocode"],
      optionss: ["all", "today", "week", "month"],
      isSelected: null,
      Impressions: "",
      saImpressions: "",
      charts: [],
      chartkey: [],
      checkFreeCampaign: [],
      dataa: [
        // {
        //     name: "Ad loops",
        //     value: "",
        //     icon: "Impressions",
        //     info: "From total loops",
        // },
        {
          name: "Distance Covered",
          value: "",
          icon: "DistanceCovered",
          info: "From total KMs",
        },
      ],
      camp_id: null,
      conversionsCampaign: 0,
      awarenessCampaign: 0,
      activeConversionsCount: 0,
      activeAwarenessCount: 0,
      AllUsers: 0,
      OfflineUsers: 0,
      OnlineUsers: 0,
      date: new Date(),
      total: {},
      campaignName: [],
      campaignDate: null,
      campaignsFilter: [],
      campaignsId: [],
      selectedCampaignDates: [],
      selectedDate: null,
      selectedModulatedImpressionsBle: 0,
      selectedAdLoop: 0,
      selectedRunTime: 0,
      selectedDistanceM: 0,
      selectedNumOfUsers: 0,
      campaignSelected: false, // Flag to track if data has been fetched
      camps_id: null,
      campaignCount: 0,
    };
  },
  computed: {
    userName() {
      return localStorage.getItem("firstName");
    },
    // newPublisher() {
    //     return new_publisher;
    // },
  },
  watch: {
    selectedDate(newVal) {
      this.selectedDate = new Date(newVal).toISOString().split("T")[0];
      this.setOption(this.camps_id);
    },
  },
  methods: {
    // setOption(option) {
    //     this.selectedOption = option.campaign_title;
    //     this.isOptionsExpanded = false;
    //     this.campaignId = option.id;
    //     if (this.campaignId) {
    //         this.getHeatmapFillered();
    //     } else {
    //         this.isSelected = null;
    //         this.getHeatmap();
    //     }
    // },
    //     setOption(campaign) {
    //   this.selectedOption = campaign;
    //   // Update available dates when a campaign is selected
    //   this.selectedDate = null; // Reset selected date
    //   this.selectedCampaignDates = this.campaignsFilter[campaign];
    // },

    // async setOption(campaign) {
    //   try {
    //     const response = await axios.get("http://publish.test.dkilo.net/api/DetailedCampaigns", {
    //       headers: {
    //         token: localStorage.getItem("token"),
    //         "Country-Code": localStorage.getItem("country_code")
    //       },
    //     });

    //     // const responseData = response.data; // Assuming response.data contains the campaign data
    //     const campaigns = response.data.campagins;
    //     console.log(campaigns);
    //     const campaignData = campaigns[campaign];
    //     console.log(campaignData);
    //     this.selectedOption = campaign;
    //         //         const selectedDate = this.selectedDate;

    //         //         try {
    //         //             const response = await axios.get("http://publish.test.dkilo.net/api/DetailedCampaigns", {
    //         //             headers: {
    //         //                 token: localStorage.getItem("token"),
    //         //                 "Country-Code": localStorage.getItem("country_code")
    //         //             },
    //         //             });

    //         //             const campaigns = response.data.campagins; // Fixed typo: changed 'campagins' to 'campaigns'
    //         //             console.log(campaigns);
    //         //             const selectedCampaign = campaigns[campaign];

    //     if (campaignData) {
    //       campaignData.forEach(campaignItem => {
    //         console.log(`Campaign ID: ${campaign}`);
    //         console.log(`Name: ${campaignItem.name}`);
    //         console.log(`Starts At: ${campaignItem.starts_at}`);
    //         console.log(`Ends At: ${campaignItem.ends_at}`);
    //         console.log(`Ad Loop: ${campaignItem.ad_loop}`);
    //         // ... Access other properties as needed
    //       });
    //     } else {
    //       console.log(`Campaign with ID ${campaign} not found.`);
    //       // Handle accordingly if the provided campaign is not found in the data
    //     }

    //     const selectedDate = this.selectedDate;
    //     const selectedCampaign = campaigns[campaign];

    //     const selectedCampaignDetails = selectedCampaign.find(item => item.created_at === selectedDate);

    //     if (selectedCampaignDetails) {
    //       const {
    //         modulated_impressions_ble,
    //         ad_loop,
    //         run_time,
    //         distance_m,
    //         num_of_users
    //       } = selectedCampaignDetails;

    //       console.log('Selected Campaign Details for Date:', selectedDate);
    //       console.log('modulated_impressions_ble:', modulated_impressions_ble);
    //       console.log('ad_loop:', ad_loop);
    //       console.log('run_time:', run_time);
    //       console.log('distance_m:', distance_m);
    //       console.log('num_of_users:', num_of_users);

    //       this.selectedModulatedImpressionsBle = modulated_impressions_ble;
    //       this.selectedAdLoop = ad_loop;
    //       this.selectedRunTime = run_time;
    //       this.selectedDistanceM = distance_m;
    //       this.selectedNumOfUsers = num_of_users;
    //     } else {
    //       console.log('No details found for the selected date:', selectedDate);
    //       // Reset or handle accordingly in your application if no details are found for the selected date
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     // Handle errors occurred during API request
    //   }
    // }
    async setOption(campaignId) {
      this.isOptionsExpanded = false;
      this.campaignSelected = true;

      try {
        const response = await axios.get(
          "http://publish.test.dkilo.net/api/DetailedCampaigns",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );

        const campaigns = response.data.campagins;
        this.camps_id = campaignId;
        this.selectedOption = campaigns[campaignId][0].name;
        if (this.camps_id in campaigns) {
          const campaignData = campaigns[this.camps_id];

          const availableDates = campaignData.map((item) => item.created_at);
          this.selectedCampaignDates = availableDates;
          if (this.selectedDate == null) {
            this.selectedDate = this.selectedCampaignDates[0];
          }
          // console.log(this.selectedDate);
          // console.log(this.camps_id);

          const selectedDate = this.selectedDate;

          const selectedCampaign = campaignData;

          const selectedCampaignDetails = selectedCampaign.find(
            (item) => item.created_at === selectedDate
          );

          if (selectedCampaignDetails) {
            const {
              modulated_impressions_ble,
              ad_loop,
              run_time,
              distance_m,
              num_of_users,
            } = selectedCampaignDetails;

            // console.log('Selected Campaign Details for Date:', selectedDate);
            // console.log('modulated_impressions_ble:', modulated_impressions_ble);
            // console.log('ad_loop:', ad_loop);
            // console.log('run_time:', run_time);
            // console.log('distance_m:', distance_m);
            // console.log('num_of_users:', num_of_users);

            this.selectedModulatedImpressionsBle = modulated_impressions_ble;
            this.selectedAdLoop = ad_loop;
            this.selectedRunTime = run_time;
            this.selectedDistanceM = distance_m;
            this.selectedNumOfUsers = num_of_users;
          } else {
            console.log(
              "No details found for the selected date:",
              selectedDate
            );
          }
        } else {
          // console.log(campaignData);
          console.log(`Campaign with ID ${campaignId} not found.`);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // setOption(option) {
    //     console.log(option);
    //     this.selectedOption = option
    //     this.isOptionsExpanded = false;
    //     this.campaignId = option.id;
    //     if (this.campaignId) {
    //         this.getHeatmapFillered();
    //     } else {
    //         this.isSelected = null;
    //         this.getHeatmap();
    //     }
    // },
    changeSelectVal(val) {
      this.isSelected = val;
      this.getHeatmapFillered();
    },
    // async getHeatmapFillered() {
    //     let param = {};
    //     this.isSelected != null
    //         ? (param = { duration: this.isSelected, campaign_id: this.campaignId })
    //         : "";
    //     store.commit("toggleLoading");
    //     try {
    //         const response = await axios
    //             .get("http://publish.test.dkilo.net/api/heatmap", {
    //                 headers: { token: localStorage.getItem("token") ,"Country-Code": this.$store.state.auth.country_code },
    //                 params: param,
    //             })
    //             .then((response) => {
    //                 this.points = [];
    //                 response.data.points.map((p) =>
    //                     this.points.push(
    //                         new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
    //                     )
    //                 );
    //                 this.dataa[0].value = response.data.AdLoop;
    //                 this.Impressions = response.data.impressions;
    //                 this.dataa[1].value = response.data.distance/1000;
    //                 store.commit("toggleLoading");
    //             });
    //     } catch (error) {
    //         store.commit("toggleLoading");
    //     }
    // },
    async getHeatmap() {
      store.commit("toggleLoading");
      try {
        const response = await axios
          .get("https://publish.dkilo.com/api/heatmap", {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
            params: {
              campaign_id: this.camp_id,
            },
          })
          .then((response) => {
            // this.points = [];
            // response.data.points.map((p) =>
            //     this.points.push(
            //         new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
            //     )
            // );
            this.charts = [];
            this.charts = response.data.chart;
            // this.dataa[0].value = response.data.AdLoop / 4;
            // this.dataa[0].value = Math.round(response.data.AdLoop / 4); delete adloops
            if (localStorage.getItem("country_code") === "SA") {
              // this.Impressions = response.data.impressions_ble;
              this.Impressions = response.data.impressions_ble.toLocaleString();
            } else if (localStorage.getItem("country_code") === "EG") {
              this.Impressions = response.data.impressions.toLocaleString();
            }
            // this.dataa[1].value = response.data.distance / 1000;
            this.dataa[0].value = Math.round(
              response.data.distance / 1000
            ).toLocaleString();
            store.commit("toggleLoading");
          });
      } catch (error) {
        store.commit("toggleLoading");
      }
    },
    async getCampaign() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/campaigns",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );

        this.campaign = response.data.campaigns;
        this.campaign.forEach((el) => this.campaignIds.push(el));
        this.campaignIds.unshift({ campaign_title: "All" });
        // this.selectedOption = this.campaignIds[0].campaign_title;
        // console.log(this.campaign);
        this.camp_id = response.data.campaigns[0].id;
      } catch (error) {
        console.log(error);
      }
    },
    // async getHeatmapReload() {
    //     try {
    //         const response = await axios
    //             .get("http://publish.test.dkilo.net/api/heatmap", {
    //                 headers: { token: localStorage.getItem("token"),
    //                 "Country-Code": this.$store.state.auth.country_code ,
    //                 'campaign_id':this.camp_id,},
    //                 params:{campaign_id:this.camp_id}
    //             })
    //             .then((response) => {
    //                 this.points = [];
    //                 response.data.points.map((p) =>
    //                     this.points.push(
    //                         new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
    //                     )
    //                 );

    //                 this.dataa[0].value = response.data.AdLoop;
    //                 this.Impressions = response.data.impressions;
    //                 this.dataa[1].value = response.data.distance / 1000;
    //             });
    //     } catch (error) {
    //         // store.commit("toggleLoading");
    //         console.log(error);
    //     }
    // },
    async getHeatmapReload() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/heatmap",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
            // params: {
            //     campaign_id: this.camp_id
            // }
          }
        );

        // this.points = [];
        // response.data.points.map((p) =>
        //     this.points.push(
        //         new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
        //     )
        // );
        // this.dataa[0].value = response.data.AdLoop;
        // this.dataa[0].value = Math.round(response.data.AdLoop / 4); delete adloops
        if (localStorage.getItem("country_code") === "SA") {
          this.Impressions = response.data.impressions_ble.toLocaleString();
        } else if (localStorage.getItem("country_code") === "EG") {
          this.Impressions = response.data.impressions.toLocaleString();
        }
        // this.dataa[1].value = response.data.distance/1000;
        this.dataa[0].value = Math.round(
          response.data.distance / 1000
        ).toLocaleString();
      } catch (error) {
        console.log(error);
      }
    },
    async getAllCampaign() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/campaigns",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );
        this.campaignCount = response.data.campaigns.data.length;
        this.checkFreeCampaign.push(response.data.campaigns.data);
        let conversionsCampaign = 0;
        let awarenessCampaign = 0;
        let activeAwarenessCount = 0;
        let activeConversionsCount = 0;
        this.checkFreeCampaign.forEach((campaign) => {
          campaign.forEach((type) => {
            if (type.is_active) {
              if (type.advertising_goal === "Awareness") {
                activeAwarenessCount++;
              } else if (type.advertising_goal === "Conversions") {
                activeConversionsCount++;
              }
            }
          });

          this.checkFreeCampaign.forEach((campaign) => {
            campaign.forEach((type) => {
              if (type.advertising_goal === "Conversions") {
                conversionsCampaign++;
              } else if (type.advertising_goal === "Awareness") {
                awarenessCampaign++;
              }
            });
          });
          this.activeConversionsCount = activeConversionsCount;
          this.activeAwarenessCount = activeAwarenessCount;
          this.awarenessCampaign = awarenessCampaign;
          this.conversionsCampaign = conversionsCampaign;
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getOnlineUsers() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/OnlineUsers",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );
        this.AllUsers = response.data.AllUsers;
        this.OnlineUsers = response.data.OnlineUsers;
        this.OfflineUsers = response.data.OfflineUsers;
      } catch (error) {
        this.OnlineUsers = 3;
        this.OfflineUsers = 97;
      }
    },
    async getHeatmapPoints() {
      try {
        const response = await axios.get(
          "http://publish.test.dkilo.net/api/map",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );
        this.points = [];
        console.log(this.points);
        response.data.points.map((p) =>
          this.points.push(
            new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
          )
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getScreenMap() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/ScreenMap",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );
        this.points = [];
        response.data.map((p) =>
        //new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
          this.points.push(p)
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getDetailedCampaigns() {
      try {
        const response = await axios.get(
          "https://publish.dkilo.com/api/DetailedCampaigns",
          {
            headers: {
              token: localStorage.getItem("token"),
              "Country-Code": localStorage.getItem("country_code"),
            },
          }
        );
        this.total = response.data.total;
        this.campaignData = response.data.campagins;
        // let campaignNameSet = new Set(); // Using a Set to store unique names
        //  Object.keys(response.data.campagins).map((campaign) => {
        //    this.campaignsId.push(campaign)
        // });
        // let campaignName = Array.from(campaignNameSet);
        // this.campaignName = campaignName;
        // this.selectedOption = campaignName[0];
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // let campaignDateSet = new Set(); // Using a Set to store unique names
        //  Object.values(response.data.campagins).map((campaign) => {
        //     console.log(campaign);
        //     campaign.map((cam) => {
        //         campaignDateSet.add(cam.created_at); // Adding names to the Set to ensure uniqueness
        //     });
        // });
        // Convert the Set back to an array
        // let campaignDate = Array.from(campaignDateSet);
        // this.campaignDate = campaignDate;
        // console.log('jajaja');
        // console.log(campaignDateSet);
        //////////////////////////////////////////////////////////////////////////////////////
        const campaigns = response.data.campagins;

        //     const campaignCreatedAtMap = {};

        //     Object.keys(campaigns).forEach((campaignId) => {
        //     const campaignDetails = campaigns[campaignId];
        //     campaignDetails.forEach((campaign) => {
        //         const { name, created_at } = campaign;
        //         if (!campaignCreatedAtMap[name]) {
        //             campaignCreatedAtMap[name] = []; // Initialize an array for the campaign name if it doesn't exist
        //         }
        //         campaignCreatedAtMap[name].push(created_at);
        //     });
        // });
        // // console.log(campaignCreatedAtMap);
        const campaginsDetails = [];
        Object.keys(campaigns).forEach((campaign) => {
          const campaignName = campaigns[campaign][0].name;
          // console.log(campaignName);
          const newObj = {
            id: campaign,
            name: campaignName,
          };

          campaginsDetails.push(newObj);
        });
        this.campaignName = campaginsDetails;
        // console.log(this.campaignName);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    filteredDates() {
      if (!this.selectedCampaign) return [];
      // Filter dates based on the selected campaign
      const dates = this.campaignData[this.selectedCampaign].map(
        (campaign) => campaign.created_at
      );
      return [...new Set(dates)];
    },
  },
  created() {
    // this.getHeatmap();
    // this.getCampaign();
    // this.getAllCampaign();
    // this.getHeatmapPoints();
    // this.getOnlineUsers();
  },
  mounted() {
    store.dispatch("me");
    store.dispatch("meFromV");
    //this.getCampaign();
    this.getAllCampaign();
    this.getOnlineUsers();
    //this.getDetailedCampaigns();
    this.getScreenMap();
    // this.getHeatmap();
     this.updateTimer = setInterval(() => {
         this.getScreenMap();
         this.getOnlineUsers();
        // this.getHeatmapReload();
     }, 20e3);
  },
    beforeDestroy() {
    clearInterval(this.updateTimer);
  },
};
</script>

<style>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
.promo-bg {
  background-image: url('../assets/lottie/1440px.svg');
  background-size: cover;
  background-position: center;
}
</style>
